import { useMemo } from 'react';
import type { ECharts } from 'echarts';
import { createOpinionChartAxisPointerController } from './utils/syncOpinionChartDateAxisPointer';

export function useOpinionDateAxisPointerSync(
  myChart: ECharts | null,
  xAxisData: string[],
  showEventAxis: boolean,
) {
  const controller = useMemo(
    () =>
      createOpinionChartAxisPointerController(
        myChart,
        xAxisData,
        showEventAxis,
      ),
    [myChart, showEventAxis, xAxisData],
  );

  return useMemo(
    () => ({
      sync: controller.sync,
      scheduleClear: controller.scheduleClear,
      clear: controller.clear,
      setSuppressAxisPointer: controller.setSuppress,
      setKeepAxisPointer: controller.setKeep,
    }),
    [controller],
  );
}
